import { render, staticRenderFns } from "./AppSplash.vue?vue&type=template&id=6f3be1f9&"
import script from "./AppSplash.vue?vue&type=script&lang=js&"
export * from "./AppSplash.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports